import { CollapsedSidebar } from "@circle-react-shared/SettingsNav/CollapsedSidebar";
import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import {
  useIsCommunityAdmin,
  usePunditUserContext,
} from "@circle-react/contexts/punditUserContext";
import { useIsAdminOrModerator } from "@circle-react/contexts/punditUserContext";
import { isPromoCodeEnabled } from "@circle-react/helpers/communityHelpers";
import { CommunitySwitcherAppData } from "@circle-react/wrappers/CommunitySwitcherAppData";

import { CircleAIDockCommunityHeader } from "@/react/components/CircleAi/Dock/CircleAIDockCommunityHeader";
import { CircleAIDockNav } from "@/react/components/CircleAi/Dock/CircleAIDockNav";
import { CircleAIDockSection } from "@/react/components/CircleAi/Dock/CircleAIDockSection";
import { useIsAdminDockNavVisible } from "@/react/components/CircleAi/Dock/useIsAdminDockNavVisible";
import { useIsCircleAIDockNavEnabled } from "@/react/components/CircleAi/Dock/useIsCircleAIDockNavEnabled";
import { CirclePartnerBadgeCard } from "@/react/components/Layout/CirclePartnerBadge/CirclePartnerBadgeCard";
import { useIsAdminArea } from "@/react/components/SettingsApp/CompassCompat/useIsAdminArea";

import { AdminDockTree } from "./AdminDockTree";

export const DockBodyContent = () => {
  const isAdminArea = useIsAdminArea();
  const dockMode = useCircleAIShellStore(s => s.dockMode);
  const isAdminDockForced = useCircleAIShellStore(s => s.isAdminDockForced);
  const isAdmin = useIsCommunityAdmin();
  const isAdminOrModerator = useIsAdminOrModerator();
  const { currentCommunity } = usePunditUserContext();
  const isAdminDockNavVisible = useIsAdminDockNavVisible();
  const isDockNavEnabled = useIsCircleAIDockNavEnabled();
  const isPromoLockedToPlansPage = isPromoCodeEnabled(currentCommunity);

  if (isPromoLockedToPlansPage) {
    return (
      <div className="h-full min-h-0 overflow-hidden">
        <CircleAIDockCommunityHeader />
      </div>
    );
  }

  // Admins/moderators get the new dock nav (admin mode) when eligible.
  if (isAdminDockNavVisible) {
    return (
      <div className="flex h-full min-h-0 flex-col overflow-hidden">
        {/* Current community at the top: an icon button when collapsed, the
            dropdown when expanded. */}
        <div className="shrink-0">
          <CircleAIDockCommunityHeader />
        </div>
        <div className="min-h-0 flex-1 overflow-hidden">
          <CircleAIDockNav />
        </div>
        {dockMode === "expanded" && <CirclePartnerBadgeCard />}
      </div>
    );
  }

  // Legacy admin dock (new nav feature disabled). Moderators only get it on
  // admin/settings routes; isAdminDockForced remains admin-only so a future
  // forced-open path cannot dump the full legacy tree on moderators.
  const isAdminDockVisible =
    !isDockNavEnabled &&
    ((isAdminOrModerator && isAdminArea) || (isAdmin && isAdminDockForced));
  if (isAdminDockVisible) {
    return (
      <div className="flex h-full min-h-0 flex-col overflow-hidden">
        <CircleAIDockSection />
        <div className="min-h-0 flex-1 overflow-hidden">
          {dockMode === "expanded" ? <AdminDockTree /> : <CollapsedSidebar />}
        </div>
        {dockMode === "expanded" && <CirclePartnerBadgeCard />}
      </div>
    );
  }

  // Regular members always keep the community switcher; opening the
  // conversational panel must not reveal the admin nav. Clip it to the dock
  // body height: the switcher rail is `min-h-screen` (sized for the legacy
  // full-page layout), so without this wrapper it overflows the dock and the
  // dock's own scroll container shows a scrollbar even with a few communities.
  // Containing it here keeps any real overflow scrolling inside the rail —
  // mirroring the admin dock branches above.
  return (
    <div className="h-full min-h-0 overflow-hidden">
      <CommunitySwitcherAppData />
    </div>
  );
};
